import { render, staticRenderFns } from "./SubmissionWesternTractorReport.vue?vue&type=template&id=33345ff4"
import script from "./SubmissionWesternTractorReport.vue?vue&type=script&lang=js"
export * from "./SubmissionWesternTractorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports